export class UnlockPropertyRequest{
    public businessId!:string;
    public propertyId!:number;
    public clientSessionId!:string
    public userId!:string;
    public userName!:string;
}